/* ASSETS  */
import boutonLire from 'assets/img/bouton_lire.png';
import boutonLireHoover from 'assets/img/bouton_lire_hoover.png';
import boutonRegarder from 'assets/img/bouton_regarder.png';
import boutonRegarderHoover from 'assets/img/bouton_regarder_hoover.png';
import boutonCoeur from 'assets/img/bouton_coeur.png';
import boutonCoeurHoover from 'assets/img/bouton_coeur_hoover.png';
import homeIconBlack from 'assets/img/home-icon-black.png';

import blockBlancFakeChoiceSmall from 'assets/img/bloc_blanc_fakechoice_small.png';
import blockBlancFakeChoiceMedium from 'assets/img/bloc_blanc_fakechoice_medium.png';

/* FOREGROUND */
import epilogue_silhouette from 'assets/img/journey/sifa/silhouette_epilogue.png';

/* BACKGROUND */
import baseBackgroundImg from 'assets/img/home-background-min.jpg';
import backgroundChoice from 'assets/img/journey/sifa/silhouette_choice.png';
import backgoundPurple from 'assets/img/backgound_purple.jpg';
import sifaBG1 from 'assets/img/journey/sifa/01_MINE_01-min.jpg';
import sifaBG2 from 'assets/img/journey/sifa/02_MINE_02-min.jpg';
import sifaBG3 from 'assets/img/journey/sifa/03_MINE_03-min.jpg';
import sifaBG4 from 'assets/img/journey/sifa/04_COLLINES-min.jpg';
import sifaBG5 from 'assets/img/journey/sifa/05_PETITE_VILLE-min.jpg';
import sifaBG6 from 'assets/img/journey/sifa/06_PIEDS_MILITAIRES-min.jpg';
import sifaBG7 from 'assets/img/journey/sifa/07_BUKAVU-min.jpg';
import sifaBG8 from 'assets/img/journey/sifa/08_COUSINS-min.jpg';
import sifaBG9 from 'assets/img/journey/sifa/09_BUKAVU_02-min.jpg';
import sifaBG10 from 'assets/img/journey/sifa/10_MAMAN-min.jpg';
import sifaBG11 from 'assets/img/journey/sifa/11_CAMP_OUGANDA_01-min.jpg';
import sifaBG12 from 'assets/img/journey/sifa/12_CAMP_OUGANDA_02-min.jpg';
import sifaBG13 from 'assets/img/journey/sifa/13_CAMP_OUGANDA_03-min.jpg';
import sifaBG14 from 'assets/img/journey/sifa/14_REINSTALLATION-min.jpg';
import sifaBG15 from 'assets/img/journey/sifa/15_2B6KT35_retouche-min.jpg';
import sifaBG16 from 'assets/img/journey/sifa/16_FB39NA-min.jpg';

/* MAPS */
import mapBukavu from 'assets/img/journey/sifa/congo_carte_1-min.png';
import mapKampala from 'assets/img/journey/sifa/congo_carte_2-min.png';

/* SOUNDS */
import soundIntro from 'assets/sounds/sifa_fr/SIFA_FR_INTRO.mp3';
import SIFA_FR_SEQ01 from 'assets/sounds/sifa_fr/SIFA_FR_SEQ01.mp3';
import SIFA_FR_SEQ02 from 'assets/sounds/sifa_fr/SIFA_FR_SEQ02.mp3';
import SIFA_FR_SEQ03 from 'assets/sounds/sifa_fr/SIFA_FR_SEQ03.mp3';
import SIFA_FR_SEQ04 from 'assets/sounds/sifa_fr/SIFA_FR_SEQ04.mp3';
import SIFA_FR_SEQ05 from 'assets/sounds/sifa_fr/SIFA_FR_SEQ05.mp3';
import SIFA_FR_SEQ06 from 'assets/sounds/sifa_fr/SIFA_FR_SEQ06.mp3';
import SIFA_FR_SEQ07 from 'assets/sounds/sifa_fr/SIFA_FR_SEQ07.mp3';
import SIFA_FR_SEQ08 from 'assets/sounds/sifa_fr/SIFA_FR_SEQ08.mp3';
import SIFA_FR_SEQ09 from 'assets/sounds/sifa_fr/SIFA_FR_SEQ09.mp3';
import SIFA_FR_SEQ10 from 'assets/sounds/sifa_fr/SIFA_FR_SEQ10.mp3';
import SIFA_FR_SEQ11 from 'assets/sounds/sifa_fr/SIFA_FR_SEQ11.mp3';
import SIFA_FR_SEQ12 from 'assets/sounds/sifa_fr/SIFA_FR_SEQ12.mp3';
import SIFA_FR_SEQ13 from 'assets/sounds/sifa_fr/SIFA_FR_SEQ13.mp3';
import SIFA_FR_SEQ14 from 'assets/sounds/sifa_fr/SIFA_FR_SEQ14.mp3';
import SIFA_FR_SEQ15 from 'assets/sounds/sifa_fr/SIFA_FR_SEQ15.mp3';
import SIFA_FR_SEQ16 from 'assets/sounds/sifa_fr/SIFA_FR_SEQ16.mp3';
import SIFA_FR_EPILOGUE1 from 'assets/sounds/sifa_fr/SIFA_FR_EPILOGUE01.mp3';
import SIFA_FR_EPILOGUEBukavu from 'assets/sounds/sifa_fr/SIFA_FR_EPILOGUE02.mp3';
import SIFA_FR_EPILOGUEKamaplaSolo from 'assets/sounds/sifa_fr/SIFA_FR_EPILOGUE03.mp3';
import SIFA_FR_EPILOGUEKamaplaGroupe from 'assets/sounds/sifa_fr/SIFA_FR_EPILOGUE04.mp3';
import SIFA_FR_EPILOGUEFIN1 from 'assets/sounds/sifa_fr/SIFA_EPILOGFIN1.mp3';
import SIFA_FR_EPILOGUEFIN2 from 'assets/sounds/sifa_fr/SIFA_EPILOGFIN2.mp3';
import SIFA_FR_EPILOGUEFIN3 from 'assets/sounds/sifa_fr/SIFA_EPILOGFIN3.mp3';

import PhylactereChezNous from 'assets/img/journey/sifa/phylactere_la_vie.png';
import PhylactereFrere from 'assets/img/journey/sifa/phylactere_mes_freres.png';
import { getYoutubeIframe } from './utils';

const choiceButtonStyle = { marginLeft: 'auto', marginRight: 'auto', marginTop: 20, padding: '30px!important', minHeight: 100, maxWidth: 250, color: 'white' };

const otherChoiceButtonStyle = {
  ...choiceButtonStyle,
  fontSize: '1.5rem!important',
  fontWeight: '700!important',
  color: 'black!important',
  maxWidth: 200,
  backgroundImage: `url(${blockBlancFakeChoiceSmall})!important`,
  '&:hover': { textDecoration: 'underline' },
};

const base_choice_style = {
  containerStyle: {
    backgroundColor: 'white',
    color: 'black',
  },
  fixedImageBackground: backgroundChoice,
  fixedImageBackgroundStyle: {
    backgroundSize: '35% auto',
    backgroundPosition: '95% center',
  },

  homeIcon: homeIconBlack,
  homeHoverIcon: homeIconBlack,

  contentStyle: {
    width: '50%',
    maxWidth: '1150px',
    marginLeft: '10%',
  },
};

const epilogeAnimationTiming = 2500;
const epilogeSoundAdditionalDelay = 1500;
const base_epilogue = {
  type: 'epilogue',
  background: { src: backgoundPurple },
  foreground: {
    src: epilogue_silhouette,
    // style: { height: '80vh', position: 'relative', top: '10vh', left: '-18vw', opacity: 1, transition: 'transform linear', transform: 'scale(1)', transformOrigin: '44.46% 71.64%' },
    style: {
      height: '80vh',
      position: 'relative',
      top: '10vh',
      left: '-18vw',
      opacity: 0,
      animationFillMode: 'forwards',
      animationTimingFunction: 'linear',
      transform: 'scale(.8)',
      transformOrigin: '44.46% 71.64%',
    },
    animations: [{ delay: 250, style: { animationName: 'opacityNoneToFull', animationDuration: `${epilogeAnimationTiming}ms` } }],
  },
};

const colors = {
  violet: '#5A36E4',
};

export const sifa_fr = {
  description: {
    name: 'Sifa',
    age: '12',
    city: 'Mbau (Sud-Kivu)',
    country: 'RD CONGO',
    text: "Comme tout le monde dans mon village, mes deux parents travaillent à la mine. Je suis déjà grande et, quand ils sont absents, je prends soin de mes deux petits frères. Mon père est creuseur et ma mère concasse des cailloux. Cette mine me fait peur. Mon oncle est mort dans un éboulement il y a quelques années... Mais sans l'argent des minerais, on ne pourrait pas vivre. Je me demande à quoi ces minerais servent, et qui en a tant besoin.",
    sound: soundIntro,
  },
  additionalLoad: [
    { type: 'img', src: backgoundPurple },
    { type: 'img', src: epilogue_silhouette },
    { type: 'img', src: blockBlancFakeChoiceSmall },
    { type: 'img', src: blockBlancFakeChoiceMedium },
    { type: 'img', src: PhylactereChezNous },
    { type: 'img', src: PhylactereFrere },
    { type: 'img', src: boutonLire },
    { type: 'img', src: boutonLireHoover },
    { type: 'img', src: boutonRegarder },
    { type: 'img', src: boutonRegarderHoover },
    { type: 'img', src: boutonCoeur },
    { type: 'img', src: boutonCoeurHoover },
  ],
  steps: [
    {
      id: 'SIFA 01',
      type: 'sequence',
      sound: SIFA_FR_SEQ01,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'Il y a eu un accident \u00e0 la mine. ', delay: 5090 },
        { type: 'text', text: 'Mon p\u00e8re a la jambe cass\u00e9e et ne peut plus travailler.', delay: 2010 },
        { type: 'text', text: "Mes parents nous disent que l'un d'entre nous \ndoit aller travailler avec ma m\u00e8re,", delay: 3040 },
        { type: 'text', text: "sinon, nous n'aurons plus assez d'argent pour acheter \u00e0 manger. ", delay: 3070 },
        { type: 'text', text: "Ils pensent qu'un de mes fr\u00e8res devrait y aller. ", delay: 3930 },
        { type: 'text', text: "C'est vrai que les hommes gagnent plus d'argent que les femmes dans la mine\u2026", delay: 2060 },
        { type: 'text', text: 'Mais mes petits fr\u00e8res sont si jeunes', delay: 3800 },
        { type: 'text', text: 'et les enfants passent dans des petites galeries tr\u00e8s dangereuses.', delay: 1180 },
        { type: 'text', text: "Je pourrais me proposer pour y aller \u00e0 sa place. \nMais on gagnerait moins d'argent... ", delay: 3830 },
        { type: 'text', text: '', delay: 4990 },
        { type: 'goToNext', delay: 4170 },
      ],
      background: {
        src: sifaBG1,
        style: {}, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: '37120ms', animationName: 'scale20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: 'info1',
    },
    {
      id: 'choice1',
      type: 'choice',

      ...base_choice_style,
      contentText:
        'Que ferais-tu si tu étais à ma place&nbsp;?<br/>Proposerais-tu à tes parents de <span class="background-underlined large">te laisser travailler</span> à la mine, ou laisserais-tu ton <span class="background-underlined very-large">petit frère y aller</span>&nbsp;?',
      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: 'Convaincre tes parents de te laisser travailler à la mine',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'SIFA 02',
        },
        {
          type: 'button',
          key: 'button-2',
          text: 'Laisser ton petit frère y aller',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'SIFA 03',
        },
      ],
    },
    {
      id: 'SIFA 02',
      type: 'sequence',
      sound: SIFA_FR_SEQ02,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'Cela fait d\u00e9j\u00e0 plusieurs semaines que je travaille \u00e0 la mine. ', delay: 4560 },
        { type: 'text', text: 'Le travail est encore plus dur que je le pensais. ', delay: 2120 },
        { type: 'text', text: 'Je transporte des sacs de cailloux entre la mine et les femmes, ', delay: 2980 },
        { type: 'text', text: 'et je concasse aussi un peu. ', delay: 3010 },
        { type: 'text', text: 'Je pense beaucoup \u00e0 mon fr\u00e8re.', delay: 2020 },
        { type: 'text', text: "Je suis soulag\u00e9e qu'il ne soit pas dans ces minuscules galeries \navec d'autres enfants creuseurs.", delay: 1940 },
        { type: 'text', text: "Ces derniers jours, j'ai remarqu\u00e9 qu'il se passait quelque chose autour de la mine... ", delay: 5050 },
        { type: 'text', text: "Au d\u00e9but, il n'y avait que quelques hommes avec des fusils, \n\u00e0 nous regarder travailler. ", delay: 3970 },
        { type: 'text', text: 'Mais ils sont de plus en plus nombreux chaque jour.', delay: 3990 },
        { type: 'text', text: '', delay: 4860 },
        { type: 'goToNext', delay: 4020 },
      ],
      background: {
        src: sifaBG2,
        style: {
          '--imageWidth': '140vw',
          '--scale': 'calc(6/7)', //6/7
          '--imageHeight': 'calc(140vw * 2/3)',
          width: 'var(--imageWidth)',
          height: 'var(--imageHeight)', //'auto',
          transformOrigin: 'top left',
          transform: 'scale(var(--scale)) translateX(0) translateY(calc( -1/2*var(--scale)*var(--imageHeight) + 50vh ) )',
          // transition: 'transform linear',
        },
        animations: [{ delay: 50, style: { animationDuration: '37970ms', animationName: 'animationSifa2' } }], // transform: 'scale(1) translateX(-40vw) translateY(0)' // translateY(calc( -1/2*var(--imageHeight) + 50vh ) )
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: 'SIFA 04',
    },
    {
      id: 'SIFA 03',
      type: 'sequence',
      sound: SIFA_FR_SEQ03,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: "Je n'ai pas os\u00e9 me proposer \u00e0 la place de mon fr\u00e8re. ", delay: 8080 },
        { type: 'text', text: "J'ai honte. ", delay: 2970 },
        { type: 'text', text: "Quand je ne m'occupe pas de la maison, \nje viens le voir, je lui apporte de l'eau. ", delay: 1010 },
        { type: 'text', text: 'Je suis tr\u00e8s inqui\u00e8te pour lui.', delay: 4090 },
        { type: 'text', text: 'Il rentre dans des minuscules galeries o\u00f9 il a du mal \u00e0 respirer. ', delay: 2000 },
        { type: 'text', text: "C'est un des plus petits gar\u00e7ons qui travaillent \u00e0 la mine.", delay: 3940 },
        { type: 'text', text: "Ces derniers jours, je ne m'inqui\u00e8te plus seulement pour mon fr\u00e8re\u2026", delay: 2930 },
        { type: 'text', text: 'Il se passe quelque chose autour de la mine.', delay: 2990 },
        { type: 'text', text: "Au d\u00e9but, il n'y avait que quelques hommes \navec des fusils, \u00e0 nous regarder travailler. ", delay: 2160 },
        { type: 'text', text: 'Mais ils sont de plus en plus nombreux chaque jour.', delay: 4860 },
        { type: 'text', text: '', delay: 3970 },
        { type: 'goToNext', delay: 5070 },
      ],
      background: {
        src: sifaBG3,
        style: {}, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: '44020ms', animationName: 'scale20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      //   textBackgroundColor: '#af8d69',
      nextStepId: 'SIFA 04',
    },
    {
      id: 'SIFA 04',
      type: 'sequence',
      sound: SIFA_FR_SEQ04,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: "Alors que je rentrais vers la maison, j'ai crois\u00e9 des gens \nqui couraient et me hurlaient de m'enfuir.", delay: 6170 },
        { type: 'text', text: 'Ils \u00e9taient poursuivis par des hommes avec des fusils et des machettes.', delay: 5890 },
        { type: 'text', text: "Je n'ai pas r\u00e9fl\u00e9chi, je me suis enfuie dans la brousse. ", delay: 3980 },
        { type: 'text', text: "O\u00f9 est ma famille&thinsp;? \nQu'est-ce qui leur est arriv\u00e9&thinsp;?", delay: 3970 },
        { type: 'text', text: "Si je reste dans le coin, j'ai une chance de les retrouver.", delay: 2990 },
        { type: 'text', text: 'Mais je ne peux pas me faire prendre par la bande arm\u00e9e. ', delay: 3150 },
        { type: 'text', text: "Je sais ce qu'ils font&thinsp;: ils violent et ils tuent. ", delay: 3050 },
        { type: 'text', text: 'En m\u2019\u00e9loignant du village, je serai plus en s\u00e9curit\u00e9.', delay: 4010 },
        { type: 'text', text: '', delay: 4970 },
        { type: 'goToNext', delay: 6010 },
      ],
      background: {
        src: sifaBG4,
        style: {}, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: '44140ms', animationName: 'scale20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      //   textBackgroundColor: '#af8d69',
      nextStepId: 'info2',
    },
    //5
    {
      id: 'choice2',
      type: 'choice',

      ...base_choice_style,
      contentText:
        "Je ne sais vraiment pas quoi faire... Que ferais-tu, toi&nbsp;?<br/>Resterais-<span class='background-underlined large'>tu près du village</span> pour retrouver ta famille, ou te mettrais-tu <span class='background-underlined large'>en sécurité en t'él</span>oignant&nbsp;?",
      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: 'Rester dans les environs',
          buttonStyle: choiceButtonStyle,
          action: 'fakeChoice',
          actionText:
            "Je suis restée dans les collines avec d'autres villageois pendant plusieurs jours après l'attaque. Ce matin, nous avons entendu des tirs et des cris... La bande armée se rapproche&thinsp;! Même si je ne sais toujours pas ce qu'il est arrivé à ma famille, je ne peux plus rester ici.",
          actionTextStyle: { backgroundImage: `url(${blockBlancFakeChoiceMedium})`, maxHeight: '60vh', width: '40vw', maxWidth: '500px' },
        },
        {
          type: 'button',
          key: 'button-2',
          text: 'Fuir le village',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'SIFA 05',
        },
      ],
    },
    {
      id: 'SIFA 05',
      type: 'sequence',
      sound: SIFA_FR_SEQ05,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: "En suivant une piste, j'ai rejoint une petite ville du district.", delay: 4100 },
        { type: 'text', text: 'Nous \u00e9tions nombreux \u00e0 y avoir fui.', delay: 3930 },
        { type: 'text', text: "Des amis du village m'ont prise avec eux.", delay: 2070 },
        { type: 'text', text: 'Quelques jours plus tard, nous avons entendu dire \nque la bande arm\u00e9e avait quitt\u00e9 la r\u00e9gion', delay: 2120 },
        { type: 'text', text: 'et nous sommes tous rentr\u00e9s \u00e0 Mbau. ', delay: 3940 },
        { type: 'text', text: "J'ai retrouv\u00e9 mon p\u00e8re et mes deux fr\u00e8res en vie, \nquel bonheur. ", delay: 2950 },
        { type: 'text', text: "Mais ma m\u00e8re n'est pas l\u00e0... ", delay: 4040 },
        { type: 'text', text: "On me raconte qu'elle a \u00e9t\u00e9 viol\u00e9e, \net qu'elle est partie avec ma tante en recherche d'un m\u00e9decin. ", delay: 1980 },
        { type: 'text', text: "Maintenant, c'est moi la femme de la maison ", delay: 5020 },
        { type: 'text', text: 'et mes deux fr\u00e8res ont repris le travail \u00e0 la mine. ', delay: 2070 },
        { type: 'text', text: 'Toujours la mine.', delay: 2880 },
        { type: 'text', text: '', delay: 3060 },
        { type: 'goToNext', delay: 2020 },
      ],
      background: {
        src: sifaBG5,
        style: { transform: 'scale(1.2)', transition: 'transform linear' }, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: '40130ms', animationName: 'scaleDown20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      //   textBackgroundColor: '#af8d69',
      nextStepId: 'SIFA 06',
    },
    {
      id: 'SIFA 06',
      type: 'sequence',
      sound: SIFA_FR_SEQ06,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'Il y a eu une nouvelle attaque avant-hier \net nous avons fui. Encore. ', delay: 3060 },
        { type: 'text', text: "Des hommes arm\u00e9s ont attrap\u00e9 mon p\u00e8re. \nNous ne l'avons pas revu depuis\u2026", delay: 4130 },
        { type: 'text', text: "Mes fr\u00e8res et moi sommes avec d'autres jeunes dans les collines.", delay: 4870 },
        { type: 'text', text: 'Nous avons faim et soif. ', delay: 2950 },
        { type: 'text', text: "Des combattants d'une bande arm\u00e9e rivale nous ont approch\u00e9s. ", delay: 2190 },
        { type: 'text', text: 'Si nous rejoignons leur groupe, ils nous promettent de venger nos familles ', delay: 3010 },
        { type: 'text', text: 'et de r\u00e9cup\u00e9rer notre territoire. ', delay: 2940 },
        { type: 'text', text: 'Certains jeunes sont tent\u00e9s. \nMes fr\u00e8res et moi, nous h\u00e9sitons. ', delay: 2930 },
        { type: 'text', text: 'Si nous acceptons, nous serons prot\u00e9g\u00e9s par la bande. ', delay: 4000 },
        { type: 'text', text: 'Je rappelle \u00e0 mes fr\u00e8res que nous avons des cousins \u00e0 Bukavu.', delay: 3120 },
        { type: 'text', text: "Nous pourrions essayer d'y aller&thinsp;? ", delay: 3000 },
        { type: 'text', text: 'Mais la ville est tr\u00e8s loin et nous courons beaucoup de risques \nen partant sur les routes \u00e0 trois.', delay: 2800 },
        { type: 'text', text: '', delay: 4190 },
        { type: 'goToNext', delay: 5830 },
      ],
      background: {
        src: sifaBG6,
        style: {}, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: '48970ms', animationName: 'scale20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      //   textBackgroundColor: '#af8d69',
      nextStepId: 'info3',
    },
    {
      id: 'choice3',
      type: 'choice',

      ...base_choice_style,
      contentText:
        "<span class='background-underlined medium'>Quel dilemme</span>&thinsp;! Que ferais-tu, si c'était toi&nbsp;?<br/>Ferais-tu confiance aux hommes armés et r<span class='background-underlined large'>ejoindrais-tu leur bande</span>&nbsp;? Ou essayerais-tu d'aller à Bukavu pour t<span class='background-underlined large'>rouver tes cousins,</span> malgré les risques du voyage&nbsp;?",
      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: "S'engager dans la bande armée",
          buttonStyle: choiceButtonStyle,
          action: 'showConfirmation',
          confirmationContent: {
            title: 'E<span class="background-underlined medium">s-tu certain.e</span>&nbsp;?<br/>Ces gens pourront-ils vraiment nous aider et nous protéger&nbsp;?',
            buttons: [
              {
                text: 'Oui, je suis<br/>sûr.e de moi',
                buttonStyle: choiceButtonStyle,
                action: 'goNext',
                nextStepId: 'epilogue1',
              },
              {
                text: 'Je reviens<br/>sur ma décision',
                buttonStyle: choiceButtonStyle,
                action: 'closeConfirmation',
              },
            ],
          },
        },
        {
          type: 'button',
          key: 'button-2',
          text: "Tenter d'aller à Bukavu",
          buttonStyle: choiceButtonStyle,
          action: 'showConfirmation',
          confirmationContent: {
            title:
              "E<span class='background-underlined medium'>s-tu certain.e</span>&nbsp;?<br/>Le chemin est long jusqu'à Bukavu, et je n'ose pas penser à ce qui pourrait nous arriver si nous nous faisons attaquer sur la route.",
            buttons: [
              {
                text: 'Oui, je suis<br/>sûr.e de moi',
                buttonStyle: choiceButtonStyle,
                action: 'goNext',
                nextStepId: 'mapBukavu',
              },
              {
                text: 'Je reviens<br/>sur ma décision',
                buttonStyle: choiceButtonStyle,
                action: 'closeConfirmation',
              },
            ],
          },
        },
      ],
    },
    {
      id: 'epilogue1',

      ...base_epilogue,

      sound: SIFA_FR_EPILOGUE1,
      sound_delay: epilogeAnimationTiming + epilogeSoundAdditionalDelay,
      sequence: [
        {
          delay: epilogeAnimationTiming,
          title: 'Voici à quoi ressemble ma vie dans une bande armée',
          text: "Cela fait des mois que nous vivons dans la bande armée. Ce n'est pas du tout comme je l'imaginais, je crois que la peur nous a poussés à faire une grosse erreur. Je voulais seulement retourner à Mbau et retrouver ma maison, comme on nous l'avait dit, mais c'était un mensonge. Nous devons tuer des gens, piller des villages et recruter d'autres enfants. Quelle différence entre notre bande armée et une autre&nbsp;? Nous recevons de l'alcool, on nous dit que c'est notre salaire. En buvant, j'essaye d'oublier tout ça.<br/><br/>Je veux partir d'ici, mais je ne sais pas comment faire.",
          textStyle: { left: '45vw' },
        },
      ],
      nextStepId: 'other_choices',
    },
    //10
    {
      id: 'other_choices',
      type: 'choice',

      ...base_choice_style,

      fixedImageBackground: baseBackgroundImg,

      fixedImageBackgroundStyle: {
        backgroundSize: '100% 100%',
        backgroundPosition: 'center',
        zIndex: 0,
      },

      contentStyle: {
        width: '100%',
        maxWidth: '500px',
        marginLeft: 'auto',
        marginRight: 'auto',
        color: 'white',
        zIndex: 100,
      },

      contentTextStyle: {
        textTransform: 'none',
        textAlign: 'center',
      },
      contentText: 'Voudrais-tu savoir ce qui se serait passé si tu avais fait <span class="background-underlined large white">d’autres choix</span>&nbsp;?',

      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: 'Oui, je reviens au début du parcours',
          buttonStyle: otherChoiceButtonStyle,
          action: 'goNext',
          nextStepId: 'SIFA 01',
        },
        {
          type: 'button',
          key: 'button-2',
          text: 'Non',
          buttonStyle: otherChoiceButtonStyle,
          action: 'goNext',
          nextStepId: '-1',
        },
      ],
    },
    {
      id: 'mapBukavu',
      type: 'map',
      background: baseBackgroundImg,
      mapImage: mapBukavu,
      mapContainerClass: 'cursor-gray',
      nextStepDelay: 3500,
      nextStepId: 'SIFA 07',
    },
    {
      id: 'SIFA 07',
      type: 'sequence',
      sound: SIFA_FR_SEQ07,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'Bukavu est une grande ville pr\u00e8s de la fronti\u00e8re du Rwanda. ', delay: 6120 },
        { type: 'text', text: 'Heureusement, nous avons rejoint la ville sans probl\u00e8me', delay: 3890 },
        { type: 'text', text: ' et nous avons trouv\u00e9 nos cousins\u2026 ', delay: 2220 },
        { type: 'text', text: 'et notre m\u00e8re, qui est arriv\u00e9e ici quelques semaines avant nous. ', delay: 2790 },
        { type: 'text', text: 'Je suis si heureuse. ', delay: 3030 },
        { type: 'text', text: "Mais je me rends compte qu'elle ne va pas bien... ", delay: 1960 },
        { type: 'text', text: 'Elle dort mal, ne mange pas beaucoup.', delay: 2220 },
        { type: 'text', text: "Je sais qu'elle a \u00e9t\u00e9 viol\u00e9e \net qu'elle est enceinte.", delay: 2890 },
        { type: 'text', text: "Je ne sais pas comment elle se sent, \nje n'ose pas lui en parler. ", delay: 3090 },
        { type: 'text', text: 'Mes cousins sont gentils, mais ils \u00e9taient ennuy\u00e9s en nous voyant arriver.', delay: 3880 },
        { type: 'text', text: 'Pour eux, cela va faire trois personnes de plus \u00e0 nourrir. ', delay: 3920 },
        { type: 'text', text: 'Pourtant, nous ne pouvons pas retourner \u00e0 Mbau.', delay: 2200 },
        { type: 'text', text: '', delay: 4870 },
        { type: 'goToNext', delay: 2990 },
      ],
      background: {
        src: sifaBG7,
        style: { animationFillMode: 'forwards', animationTimingFunction: 'linear' },
        animations: [{ delay: 50, style: { animationName: 'scale20', animationDuration: '46020ms' } }],
      },
      //   textBackgroundColor: '#af8d69',
      nextStepId: 'SIFA 08',
    },
    {
      id: 'SIFA 08',
      type: 'sequence',
      sound: SIFA_FR_SEQ08,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: "Mes cousins ne vont pas nous jeter \u00e0 la rue\nmais cela leur faciliterait la vie qu'on parte. ", delay: 2110 },
        { type: 'text', text: 'Mais pour aller o\u00f9&thinsp;? ', delay: 4990 },
        { type: 'text', text: 'Certains Congolais partent en Ouganda ;\nmais pour quel avenir&thinsp;? ', delay: 1930 },
        { type: 'text', text: 'J\u2019entends dire beaucoup de choses sur l\u2019Ouganda. ', delay: 4030 },
        { type: 'text', text: 'Certains disent que le gouvernement donne des terres aux r\u00e9fugi\u00e9s ', delay: 2940 },
        { type: 'text', text: 'et que l\u2019on peut cultiver.', delay: 2230 },
        { type: 'text', text: 'D\u2019autres disent qu\u2019il n\u2019y a rien l\u00e0-bas,\nque des camps de r\u00e9fugi\u00e9s o\u00f9 on s\u2019entasse. ', delay: 1950 },
        { type: 'text', text: 'Est-ce que j\u2019essayerais quand m\u00eame de convaincre mes cousins ', delay: 4890 },
        { type: 'text', text: 'que nous allons subvenir nous-m\u00eames \u00e0 nos besoins en travaillant&thinsp;? ', delay: 1980 },
        { type: 'text', text: "Nous pourrions alors rester \u00e0 Bukavu, \nau moins jusqu'\u00e0 ce que ma m\u00e8re ait accouch\u00e9.", delay: 3040 },
        { type: 'text', text: '', delay: 5130 },
        { type: 'goToNext', delay: 4850 },
      ],
      background: {
        src: sifaBG8,
        style: { width: '120vw', position: 'relative', left: '-20vw' }, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: '40020ms', animationName: 'translateX0To20vw' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      //   textBackgroundColor: '#af8d69',
      nextStepId: 'info4',
    },
    {
      id: 'choice4',
      type: 'choice',

      ...base_choice_style,
      contentText:
        'Je ne sais pas quelle est la bonne décision à prendre. Dans cette situation, que ferais-tu&nbsp;?<br/> Discu<span class="background-underlined very-large">terais-tu avec tes cousins</span> pour les convaincre de te laisser rester chez eux&nbsp;? Ou tenterais<span class="background-underlined very-large">-tu ta chance en Ouganda</span>&nbsp;?',
      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: 'Négocier avec les cousins',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'SIFA 09',
        },
        {
          type: 'button',
          key: 'button-2',
          text: 'Projeter de partir en Ouganda',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'mapKampala',
        },
      ],
    },
    //15
    {
      id: 'SIFA 09',
      type: 'sequence',
      sound: SIFA_FR_SEQ09,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: "Mes cousins nous ont laiss\u00e9 rester \n\u00e0 condition qu'on aide pour payer le loyer et la nourriture.", delay: 4180 },
        { type: 'text', text: 'Nous travaillons tous&thinsp;:', delay: 5940 },
        { type: 'text', text: ' mes fr\u00e8res aident les vendeurs au march\u00e9\net je fais du nettoyage dans un salon de coiffure. ', delay: 1100 },
        { type: 'text', text: 'Ma m\u00e8re a accouch\u00e9 de ma petite s\u0153ur.', delay: 4890 },
        { type: 'text', text: '', delay: 4950 },
        { type: 'goToNext', delay: 3130 },
      ],
      background: {
        src: sifaBG9,
        style: { width: '120vw', position: 'relative', left: '-20vw' }, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: '24140ms', animationName: 'translateX0To20vw' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      //   textBackgroundColor: '#af8d69',
      nextStepId: 'SIFA 10',
    },
    {
      id: 'SIFA 10',
      type: 'sequence',
      sound: SIFA_FR_SEQ10,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'Maintenant que ma m\u00e8re a accouch\u00e9, \nnous discutons tous ensemble de ce que nous allons faire. ', delay: 2050 },
        { type: 'text', text: 'Si nous travaillons assez, \nnous pourrons nous payer un logement \u00e0 Bukavu.', delay: 5040 },
        { type: 'text', text: "En vivant ici, j'ai entendu parler d'un docteur, ", delay: 4010 },
        { type: 'text', text: 'Monsieur Mukwege, qui "r\u00e9pare" les femmes viol\u00e9es.', delay: 2050 },
        { type: 'text', text: "J'aimerais vraiment pouvoir y emmener Maman un jour.", delay: 3940 },
        { type: 'text', text: "Mais mes fr\u00e8res reparlent de l'Ouganda&thinsp;: \nl\u00e0-bas, il n'y a pas de guerre.", delay: 2950 },
        { type: 'text', text: "Ils voudraient \u00e9tudier et ne pourront pas le faire \ns'ils doivent travailler ici. ", delay: 3970 },
        { type: 'text', text: "Pour aller en Ouganda, nous pourrions \nemprunter de l'argent \u00e0 nos cousins. ", delay: 4070 },
        { type: 'text', text: "Mais cela signifierait s'endetter envers eux.", delay: 3130 },
        { type: 'text', text: "Une autre id\u00e9e est d'essayer de traverser \nla fronti\u00e8re par nos propres moyens.", delay: 2890 },
        { type: 'text', text: '', delay: 4900 },
        { type: 'goToNext', delay: 4140 },
      ],
      background: {
        src: sifaBG10,
        style: {
          // '--imageWidth': '120vw',
          // '--scale': 'calc(5/6)',
          // '--imageHeight': 'calc(120vw * 0.67)',
          // width: 'var(--imageWidth)',
          // height: 'var(--imageHeight)',
          // transformOrigin: 'top left',
          // transform: 'scale(var(--scale)) translateX(-20vw) translateY(calc( -1/2*var(--scale)*var(--imageHeight) + 50vh ) )',
          // transform: 'scale(1)',
          transformOrigin: '0 center',
          // transition: 'transform linear',
          // width:"100vw",
        },
        animations: [{ delay: 50, style: { animationDuration: '43090ms', animationName: 'scale20' } }],
      },
      //   textBackgroundColor: '#af8d69',
      nextStepId: 'info bukavu ou ouganda',
    },
    {
      id: 'choice bukavu ou ouganda',
      type: 'choice',

      ...base_choice_style,
      contentText:
        '<span class="background-underlined medium">C’est vraim</span>ent une décision difficile... Que ferais-tu, toi&nbsp;?<br/><span class="background-underlined medium">Resterais-tu</span> à Bukavu, essayerais-tu de <span class="background-underlined large">traverser la frontière</span> vers l’Ouganda par tes propres moyens, ou <span class="background-underlined very-large">emprunterais-tu de l’argent</span> à tes cousins&nbsp;?',
      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: 'Rester à Bukavu',
          buttonStyle: choiceButtonStyle,
          action: 'showConfirmation',
          confirmationContent: {
            title:
              'Es-<span class="background-underlined medium">tu certain&middot;e</span>&thinsp;?<br/>Ici, nous ne sommes pas à l’abri de la violence, et la vie ne s<span class="background-underlined large">era pas facile tous les jou</span>rs.',
            buttons: [
              {
                text: 'Oui, je suis<br/>sûr&middot;e de moi',
                buttonStyle: choiceButtonStyle,
                action: 'goNext',
                nextStepId: 'epilogue bukavu',
              },
              {
                text: 'Je reviens<br/>sur ma décision',
                buttonStyle: choiceButtonStyle,
                action: 'closeConfirmation',
              },
            ],
          },
        },
        {
          type: 'button',
          key: 'button-2',
          text: "Partir vers l'Ouganda sans argent",
          buttonStyle: choiceButtonStyle,
          // action: 'fakeChoice',
          // actionText:
          //   'Maman ne voulait pas contracter de dette en empruntant de l’argent à nos cousins. Elle nous a envoyés, mes frères et moi, nous poster sur le bord de la route pour essayer de monter dans des camions. Nous avons essayé pendant un long moment, mais personne n’a voulu nous prendre.',
          // actionTextStyle: { backgroundImage: `url(${blockBlancFakeChoiceMedium})`, maxHeight: '60vh', width: '40vw', maxWidth: '500px' },
          action: 'showConfirmation',
          confirmationContent: {
            title:
              'Es-<span class="background-underlined medium">tu certain&middot;e</span>&thinsp;?<br/>Ça ne sera pas facile de traverser la frontière <span class="background-underlined large">sans argent</span>. ',
            buttons: [
              {
                text: 'Oui, je suis<br/>sûr&middot;e de moi',
                buttonStyle: choiceButtonStyle,
                buttonKey:'button-2',
                action: 'fakeChoice',
                actionText:
                  'Maman ne voulait pas contracter de dette en empruntant de l’argent à nos cousins. Elle nous a envoyés, mes frères et moi, nous poster sur le bord de la route pour essayer de monter dans des camions. Nous avons essayé pendant un long moment, mais personne n’a voulu nous prendre.',
                actionTextStyle: { backgroundImage: `url(${blockBlancFakeChoiceMedium})`, maxHeight: '60vh', width: '40vw', maxWidth: '500px' },
              },
              {
                text: 'Je reviens<br/>sur ma décision',
                buttonStyle: choiceButtonStyle,
                action: 'closeConfirmation',
              },
            ],
          },
        },
        {
          type: 'button',
          key: 'button-3',
          text: "Emprunter de l'argent",
          buttonStyle: choiceButtonStyle,
          action: 'showConfirmation',
          confirmationContent: {
            title:
              'Es-<span class="background-underlined medium">tu certain&middot;e</span>&thinsp;?<br/>Ça veut dire s’endetter envers les cousins. Comment allons-nous faire po<span class="background-underlined large">ur les rembourser</span>&thinsp;? ',
            buttons: [
              {
                text: 'Oui, je suis<br/>sûr&middot;e de moi',
                buttonStyle: choiceButtonStyle,
                action: 'goNext',
                nextStepId: 'mapKampala',
              },
              {
                text: 'Je reviens<br/>sur ma décision',
                buttonStyle: choiceButtonStyle,
                action: 'closeConfirmation',
              },
            ],
          },
        },
      ],
    },
    {
      id: 'epilogue bukavu',

      ...base_epilogue,

      sound: SIFA_FR_EPILOGUEBukavu,
      sound_delay: epilogeAnimationTiming + epilogeSoundAdditionalDelay,
      sequence: [
        {
          delay: epilogeAnimationTiming,
          title: 'Voici à quoi ressemble ma vie à Bukavu',
          text: "Nous avons choisi de rester à Bukavu ; c'était la solution la plus simple.<br/>Malgré tout ce qu'elle a vécu, ma mère ne voulait absolument pas quitter le pays où elle est née. J'ai pu l'accompagner à la clinique du Docteur Mukwege, j'espère qu'elle ira mieux désormais. Mes deux frères vont à l'école et, pour ma part, je m'occupe beaucoup de ma petite sœur-bébé. Malheureusement, nous sommes toujours sans nouvelles de mon père.<br/><br/> J'ai trouvé un meilleur travail, dans un bar à bière. Je suis fière de tout ce que je fais pour ma famille. J'espère que nous vivrons de nombreuses années en sécurité et en paix à Bukavu.",
          textStyle: { left: '45vw' },
        },
      ],
      nextStepId: 'other_choices',
    },
    {
      id: 'mapKampala',
      type: 'map',
      background: baseBackgroundImg,
      mapImage: mapKampala,
      mapContainerClass: 'cursor-gray',
      nextStepDelay: 3500,
      nextStepId: 'SIFA 11',
    },
    //20
    {
      id: 'SIFA 11',
      type: 'sequence',
      sound: SIFA_FR_SEQ11,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: "Avec l'argent emprunt\u00e9 \u00e0 mes cousins, ", delay: 4060 },
        { type: 'text', text: 'mes deux fr\u00e8res et moi sommes partis en bus vers le Rwanda. ', delay: 1170 },
        { type: 'text', text: 'L\u00e0-bas, nous avons dormi dehors quelques jours, ', delay: 3840 },
        { type: 'text', text: "le temps de prendre un autre transport vers la fronti\u00e8re de l'Ouganda, \npuis encore un autre... ", delay: 2010 },
        { type: 'text', text: 'Apr\u00e8s plusieurs jours, nous sommes arriv\u00e9s \ndans un camp pour r\u00e9fugi\u00e9s. ', delay: 5090 },
        { type: 'text', text: 'Il y a \u00e9norm\u00e9ment de monde, \nnous avons re\u00e7u une b\u00e2che pour faire une tente. ', delay: 4030 },
        { type: 'text', text: 'Il y a peu \u00e0 manger, et nous ne pouvons pas \ncultiver de l\u00e9gumes ni \u00e9lever des poules.', delay: 3930 },
        { type: 'text', text: '', delay: 6050 },
        { type: 'goToNext', delay: 2040 },
      ],
      background: {
        src: sifaBG11,
        style: { transform: 'scale(1.2)', transition: 'transform linear' }, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: '32170ms', animationName: 'scaleDown20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      //   textBackgroundColor: '#af8d69',
      nextStepId: 'SIFA 12',
    },
    {
      id: 'SIFA 12',
      type: 'sequence',
      sound: SIFA_FR_SEQ12,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: "Je ne suis plus certaine que c'\u00e9tait une bonne id\u00e9e de venir ici. ", delay: 2170 },
        { type: 'text', text: 'Maman est toujours \u00e0 Bukavu.', delay: 3910 },
        { type: 'text', text: "Elle nous demande comment c'est, et si on peut lui envoyer de l'argent, pour elle et le b\u00e9b\u00e9...", delay: 1950 },
        { type: 'text', text: "Dans le camp, je n'ai pas l'impression \nque l'on puisse gagner grand-chose.", delay: 5980 },
        { type: 'text', text: "Une id\u00e9e serait d'aller travailler \u00e0 Kampala, \nla capitale de l'Ouganda. ", delay: 3170 },
        { type: 'text', text: 'Mais mes deux fr\u00e8res veulent rester ici, \ncar il y a une \u00e9cole gratuite. ', delay: 4030 },
        { type: 'text', text: 'En plus, on entend parler de "r\u00e9installation". ', delay: 3910 },
        { type: 'text', text: '\u00c7a veut dire partir dans un pays tr\u00e8s loin de la RDC, \net ne jamais y revenir. ', delay: 3890 },
        { type: 'text', text: 'Mes fr\u00e8res sont fatigu\u00e9s de tout.', delay: 4200 },
        { type: 'text', text: 'Ils r\u00eavent d\'\u00eatre "r\u00e9install\u00e9s", par exemple aux Etats-Unis, \no\u00f9 tout le monde a la vie facile. ', delay: 1990 },
        { type: 'text', text: 'Moi, je suis partag\u00e9e... ', delay: 4950 },
        { type: 'text', text: '', delay: 3850 },
        { type: 'goToNext', delay: 4050 },
      ],
      background: {
        src: sifaBG12,
        style: { transform: 'scale(1.2)', transformOrigin: '100% center' }, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: '48000ms', animationName: 'scaleDown20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      //   textBackgroundColor: '#af8d69',
      nextStepId: 'info kampala',
    },
    {
      id: 'choice kampala',
      type: 'choice',

      ...base_choice_style,
      contentText:
        '<span class="background-underlined medium">Je ne sais p</span>as quoi faire. À ma place, que ferais-tu&nbsp;?<br/>Par<span class="background-underlined very-large">tirais-tu travailler seule à Kampala</span>&nbsp;? Emmènerais-tu <span class="background-underlined large">tes frères avec t</span>oi&nbsp;? Ou resterais-tu dans <span class="background-underlined large">le camp de réfugi</span>és&nbsp;?',
      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: 'Partir seule à Kampala',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'epilogue kampala solo',
        },
        {
          type: 'button',
          key: 'button-2',
          text: 'Partir ensemble à Kampala',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'epilogue kampala groupe',
        },
        {
          type: 'button',
          key: 'button-3',
          text: 'Rester tous au camp',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'SIFA 13',
        },
      ],
    },
    {
      id: 'epilogue kampala solo',

      ...base_epilogue,

      sound: SIFA_FR_EPILOGUEKamaplaSolo,
      sound_delay: epilogeAnimationTiming + epilogeSoundAdditionalDelay,
      sequence: [
        {
          delay: epilogeAnimationTiming,
          title: 'Voici à quoi ressemble ma vie à Kampala',
          text: "Je suis partie seule à Kampala, je n'ai pas voulu obliger mes frères à me suivre. En arrivant, je ne connaissais personne et j'ai trainé avec des enfants des rues.<br/>D'autres filles m'ont fait rencontrer Wilson&thinsp;: selon elles, il pouvait m'aider. Cela fait maintenant quelques années que je me prostitue. J'ai tellement honte, mais au moins, je peux envoyer de l'argent à mes frères et à ma mère. Je ne leur dirai jamais comment je gagne cet argent... J'ai souvent faim, on me frappe, je me sens misérable.<br/> Ma famille et ma vie d'avant me manquent. Si seulement je pouvais reprendre une vie normale.",
          textStyle: { left: '45vw' },
        },
      ],
      nextStepId: 'other_choices',
    },
    {
      id: 'epilogue kampala groupe',

      ...base_epilogue,

      sound: SIFA_FR_EPILOGUEKamaplaGroupe,
      sound_delay: epilogeAnimationTiming + epilogeSoundAdditionalDelay,
      sequence: [
        {
          delay: epilogeAnimationTiming,
          title: 'Voici à quoi ressemble notre vie à Kampala',
          text: "Il n'y avait pas d'avenir dans le camp, mes frères et moi avons décidé d'aller à Kampala. J'ai trouvé un boulot&thinsp;: je cuisine dans un restaurant de rue. Mes frères travaillent aussi, et nous partageons un petit logement avec une autre famille. La vie n'est pas facile, mais au moins, il n'y a pas de guerre, nous sommes ensemble et nous sommes tous en bonne santé. J'espère que ma mère, qui est toujours à Bukavu avec ma petite sœur, ne tardera plus à nous rejoindre. Malheureusement, nous sommes toujours sans nouvelles de mon père.<br/><br/>Je commence à avoir des amis parmi les Ougandais et d'autres Congolais qui ont fui le pays. Je me sens de plus en plus chez moi ici. Je crois que nous allons rester longtemps en Ouganda.",
          textStyle: { left: '45vw' },
        },
      ],
      nextStepId: 'other_choices',
    },
    //25
    {
      id: 'SIFA 13',
      type: 'sequence',
      sound: SIFA_FR_SEQ13,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: "J'ai 19 ans.", delay: 3200 },
        { type: 'text', text: 'Cela fait 6 ans que nous sommes dans le camp, maintenant. ', delay: 1860 },
        { type: 'text', text: 'Il y a quelques ann\u00e9es, Maman et ma petite s\u0153ur nous ont rejoints.', delay: 2980 },
        { type: 'text', text: "Ma petite s\u0153ur n'a pas connu d'autre vie que ce camp.", delay: 3060 },
        { type: 'text', text: 'La vie est grise ici, parfois je travaille un peu,', delay: 2980 },
        { type: 'text', text: "parfois je vais \u00e0 l'\u00e9cole pour apprendre l'anglais, ", delay: 3110 },
        { type: 'text', text: "mais j'ai l'impression que \u00e7a ne sert \u00e0 rien.", delay: 2880 },
        { type: 'text', text: 'Plusieurs fois, nous avons pens\u00e9 \u00e0 rentrer \u00e0 Mbau ', delay: 2980 },
        { type: 'text', text: 'mais la r\u00e9gion est toujours dangereuse.', delay: 2950 },
        { type: 'text', text: "Derni\u00e8rement, c'est devenu grave dans le camp.", delay: 2150 },
        { type: 'text', text: 'Les rations de nourriture sont encore r\u00e9duites,', delay: 2880 },
        { type: 'text', text: 'les gens se battent, \nil y a de plus en plus de vols et de viols.', delay: 1200 },
        { type: 'text', text: "Je ne me sens pas en s\u00e9curit\u00e9. \nJe n'en peux plus de ce camp. ", delay: 5950 },
        { type: 'text', text: 'Certaines familles sont l\u00e0 depuis 20 ans. ', delay: 4870 },
        { type: 'text', text: "Est-ce que c'est notre destin&thinsp;?", delay: 2160 },
        { type: 'text', text: '', delay: 2710 },
        { type: 'goToNext', delay: 2010 },
      ],
      background: {
        src: sifaBG13,
        style: { transformOrigin: 'center 0%' }, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: '47080ms', animationName: 'scale20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      //   textBackgroundColor: '#af8d69',
      nextStepId: 'SIFA 14',
    },
    {
      id: 'SIFA 14',
      type: 'sequence',
      sound: SIFA_FR_SEQ14,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'Un jour, nous avons appris que nous allions \u00eatre r\u00e9install\u00e9s, ', delay: 3220 },
        { type: 'text', text: 'que nous partirions en Belgique tr\u00e8s bient\u00f4t. ', delay: 3010 },
        { type: 'text', text: "Tout d'abord, je n'y croyais pas. ", delay: 3800 },
        { type: 'text', text: 'Mes fr\u00e8res \u00e9taient tr\u00e8s enthousiastes, \nmais ma m\u00e8re \u00e9tait triste et pleine de doutes. ', delay: 1990 },
        { type: 'text', text: "Elle avait toujours gard\u00e9 l'espoir \nque nous pourrions rentrer chez nous, \u00e0 Mbau. ", delay: 4160 },
        { type: 'text', text: '', delay: 5030 },
        { type: 'goToNext', delay: 1940 },
      ],
      background: {
        src: sifaBG14,
        style: {}, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: '27100ms', animationName: 'scale10' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      //   textBackgroundColor: '#af8d69',
      nextStepId: 'SIFA 15',
    },
    {
      id: 'SIFA 15',
      type: 'sequence',
      sound: SIFA_FR_SEQ15,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'Finalement, nous sommes arriv\u00e9s en Belgique. ', delay: 2190 },
        { type: 'text', text: 'Ici, les choses ne sont pas aussi simples que je le pensais. ', delay: 2930 },
        { type: 'text', text: "J'accompagne ma m\u00e8re pour faire des d\u00e9marches. ", delay: 3050 },
        { type: 'text', text: 'Apr\u00e8s \u00eatre pass\u00e9s par Fedasil, \non nous a mis dans un logement temporaire.', delay: 2840 },
        { type: 'text', text: "Les Belges n'arr\u00eatent pas de nous r\u00e9p\u00e9ter \nqu'on doit trouver un logement fixe, c'est la priorit\u00e9.", delay: 4000 },
        { type: 'text', text: '', delay: 5220 },
        { type: 'goToNext', delay: 6870 },
      ],
      background: {
        src: sifaBG15,
        style: { transform: 'scale(1.2)' }, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: '27050ms', animationName: 'scaleDown20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      //   textBackgroundColor: '#af8d69',
      nextStepId: 'SIFA 16',
    },
    {
      id: 'SIFA 16',
      type: 'sequence',
      sound: SIFA_FR_SEQ16,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: "C'est mon premier anniversaire en Belgique. \nJ'ai 20 ans. ", delay: 6050 },
        { type: 'text', text: "Qu'est-ce que je vais faire&thinsp;? ", delay: 3960 },
        { type: 'text', text: 'Ma premi\u00e8re id\u00e9e \u00e9tait de travailler pour pouvoir nous payer \nun bon logement et rembourser la dette \u00e0 mes cousins.', delay: 1160 },
        { type: 'text', text: "Mais mon assistante sociale m'a dit \nque je pourrais aussi \u00e9tudier \u00e0 temps plein.", delay: 5910 },
        { type: 'text', text: "Moi qui n'ai jamais pu \u00e9tudier, \nc'est peut-\u00eatre ma chance&thinsp;? ", delay: 4080 },
        { type: 'text', text: "Mais je n'ai jamais beaucoup \u00e9t\u00e9 \u00e0 l'\u00e9cole, \nj'ai peur de ne pas parvenir \u00e0 suivre les cours...", delay: 3930 },
        { type: 'text', text: '', delay: 6950 },
        { type: 'goToNext', delay: 8050 },
      ],
      background: {
        src: sifaBG16,
        style: { animationFillMode: 'forwards', animationTimingFunction: 'linear' },
        animations: [{ delay: 50, style: { animationName: 'scale20', animationDuration: '40040ms' } }],
      },
      backgroundEffect: {
        style: { opacity: 0, backgroundColor: 'black', transition: 'opacity linear' },
        animations: [{ delay: 32040, style: { animationName: 'opacityNoneToFull', animationDuration: '6950ms' } }],
      },
      //   textBackgroundColor: '#af8d69',
      nextStepId: 'info final',
    },
    {
      id: 'choice final',
      type: 'choice',

      ...base_choice_style,
      contentText:
        'Je ne sais pas quelle décision prendre. Toi, <span class="background-underlined medium">que ferais-tu</span>&nbsp;?<br/>Chercherais-tu <span class="background-underlined medium">du travail</span>, choisirais-tu <span class="background-underlined large">d’étudier à temps plein</span>, ou essayerais-tu <span class="background-underlined very-large">d’étudier et de travailler</span> après les cours ?',
      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: 'Travailler à temps plein',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'epilogue fin 1',
        },
        {
          type: 'button',
          key: 'button-2',
          text: "Étudier et travailler après l'école",
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'epilogue fin 3',
        },
        {
          type: 'button',
          key: 'button-3',
          text: 'Étudier à temps plein',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'epilogue fin 2',
        },
      ],
    },
    //30
    {
      id: 'epilogue fin 1',

      ...base_epilogue,

      sound: SIFA_FR_EPILOGUEFIN1,
      sound_delay: epilogeAnimationTiming + epilogeSoundAdditionalDelay,
      sequence: [
        {
          delay: epilogeAnimationTiming,
          title: 'Voici à quoi ressemble notre vie en Belgique',
          text: 'J’ai choisi de travailler le plus possible. Je n’ai jamais vraiment été à l’école, j’ai pensé que c’était trop tard pour moi. Cela n’a pas été facile de trouver du travail car je n’ai pas de diplôme. Je nettoie des bureaux durant la nuit. Je suis fière et heureuse de voir mes deux frères étudier, et apprendre plein de choses.<br/><br/>Aujourd’hui, un de mes frères m’a appris que les smartphones et les ordinateurs contiennent des minerais de chez nous. C’était pour ça, tous ces morts à la mine de mon village&nbsp;? C’est dingue! Ici, tout le monde a un smartphone et un ordinateur. Est-ce que les gens sont au courant de ça&nbsp;?!<br/><br/>Le Kivu continue de subir des violences importantes, et nous sommes toujours sans nouvelles de mon père. Je pense à tous les gens qui sont encore là-bas, et aussi ceux qui vivent dans des camps en Ouganda. J’ai de la chance par rapport à eux.',
          textStyle: { left: '45vw' },
        },
      ],
      nextStepId: 'other_choices',
    },
    {
      id: 'epilogue fin 2',

      ...base_epilogue,

      sound: SIFA_FR_EPILOGUEFIN2,
      sound_delay: epilogeAnimationTiming + epilogeSoundAdditionalDelay,
      sequence: [
        {
          delay: epilogeAnimationTiming,
          title: 'Voici à quoi ressemble notre vie en Belgique',
          text: 'J’ai décidé de saisir ma chance d’aller à l’école... Je suis beaucoup plus vieille que les autres élèves et je n’ose pas trop leur parler, car j’en ai entendu qui se moquaient de mon français “bizarre”. Résultat, je ne me fais pas vraiment d’amis... Mes frères étudient aussi, nous n’avons pour ainsi dire pas d’argent et nous vivons dans un logement social. Je culpabilise, car nous devons encore de l’argent à nos cousins de Bukavu.<br/><br/>Aujourd’hui, un de mes frères m’a appris que les smartphones et les ordinateurs contiennent des minerais de chez nous. C’était pour ça, tous ces morts à la mine de mon village&nbsp;? C’est dingue! Ici, tout le monde a un smartphone et un ordinateur. Est-ce que les gens sont au courant de ça&nbsp;?!<br/><br/>Le Kivu continue de subir des violences importantes, et nous sommes toujours sans nouvelles de mon père. Je pense à tous les gens qui sont encore là-bas, et aussi ceux qui vivent dans des camps en Ouganda. J’ai de la chance par rapport à eux.',
          textStyle: { left: '45vw' },
        },
      ],
      nextStepId: 'other_choices',
    },
    {
      id: 'epilogue fin 3',

      ...base_epilogue,

      sound: SIFA_FR_EPILOGUEFIN3,
      sound_delay: epilogeAnimationTiming + epilogeSoundAdditionalDelay,
      sequence: [
        {
          delay: epilogeAnimationTiming,
          title: 'Voici à quoi ressemble notre vie en Belgique',
          text: 'J’ai décidé de saisir ma chance d’aller à l’école... Je suis beaucoup plus vieille que les autres élèves et je n’ose pas trop leur parler, car j’en ai entendu qui se moquaient de mon français “bizarre”. Résultat, je ne me fais pas vraiment d’amis... Les professeurs me disent que, pour améliorer mes résultats scolaires, je devrais aller à l’école des devoirs, mais je n’ai simplement pas le temps&thinsp;: je travaille le soir, je nettoie des bureaux. C’est difficile de faire les deux mais, au moins, je contribue à rembourser nos cousins à Bukavu.<br/><br/>Aujourd’hui, un de mes frères m’a appris que les smartphones et les ordinateurs contiennent des minerais de chez nous. C’était pour ça, tous ces morts à la mine de mon village&nbsp;? C’est dingue! Ici, tout le monde a un smartphone et un ordinateur. Est-ce que les gens sont au courant de ça&nbsp;?!<br/><br/>Le Kivu continue de subir des violences importantes, et nous sommes toujours sans nouvelles de mon père. Je pense à tous les gens qui sont encore là-bas, et aussi ceux qui vivent dans des camps en Ouganda. J’ai de la chance par rapport à eux.',
          textStyle: { left: '45vw' },
        },
      ],
      nextStepId: 'other_choices',
    },
    {
      ...base_choice_style,
      id: 'info1',
      type: 'info',

      contentText:
        'Que ferais-tu si tu étais à ma place&nbsp;?<br/>Proposerais-tu à tes parents de <span class="background-underlined large">te laisser travailler</span> à la mine, ou laisserais-tu ton <span class="background-underlined very-large">petit frère y aller</span>&nbsp;?',
      actionText: 'Je m’informe pour aider Sifa à prendre la bonne décision :',
      actions: [
        {
          type: 'button',
          key: 'button-read-1',
          text: 'Je lis un article sur la présence des femmes dans les mines congolaises',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonLire,
          iconHover: boutonLireHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            backgroundImage: backgoundPurple,
            type: 'text',
            title: "Les Mamans Twangeuses, femmes des mines<br/><span class='subtitle'>Justice et Paix (résumé)</span>",
            text: "<span class='inline-title'>DES FEMMES INDISPENSABLES</span>Contrairement à ce que l’on pourrait penser, les femmes sont très présentes dans et autour des zones minières. En RD Congo, elles représenteraient près de la moitié des plus de deux millions de personnes travaillant dans l’exploitation artisanale. Elles jouent un rôle essentiel mais bien différent de celui des hommes et nombreuses sont victimes de discriminations. Si toute personne majeure de nationalité congolaise qui détient une carte d’exploitant.e a le droit de se livrer à l’exploitation artisanale, les femmes qui disposent d’un titre de propriété ou d’un permis d’exploitation sont assez rares. Certaines creusent, mais les tâches qui leur sont généralement réservées sont le concassage, le lavage, le tamisage, le triage et le traitement des minerais. Plusieurs raisons sont invoquées pour justifier cette répartition genrée du travail : la faiblesse présumée des femmes ou leurs menstruations qui, selon certaines superstitions, les empêcheraient d’être productives. Les tâches de celles qu’on surnomme les twangaises sont moins bien rémunérées, même lorsqu’elles exécutent les mêmes fonctions que les hommes. Enfin, les femmes sont très fréquemment celles qui s’occupent du commerce de biens et de services qui se développe autour des mines : production d’aliments, gestion des bars, restaurants, boutiques et hôtels. Elles sont ainsi souvent confrontées à l’insolvabilité des clients ou aux refus violents de payer.<span class='inline-title'>UNE VIOLENCE OMNIPRESENTE</span>Au-delà de ces aspects socio-économiques, les mines ont un impact considérable sur la vie et le corps de femmes. Et, bien que le sujet demeure tabou, les violences sexuelles sont très répandues. Selon une étude de la Banque Mondiale, 40% des femmes qui travaillent dans l’exploitation minière artisanale à l’Est de la RD Congo feraient face à des abus sexuels et/ou se prostitueraient pour travailler ou accéder à des biens de première nécessité. Ces actes de violence ne seraient pas seulement imputables aux forces armées – régulières ou rebelles - présentes dans la région, mais également à des citoyens. En plus des violences sexuelles, certaines femmes subissent quotidiennement la brutalité et le chantage des hommes, sans pouvoir même envisager de faire appel aux forces de sécurité ou aux autorités locales, qui sont souvent éloignées ou se désintéressent de leur sort. La plupart des femmes ne se sentent ainsi pas en sécurité dans les mines.<br/><br/>Ceci est un résumé de l’article de Justice et Paix <a href='https://www.justicepaix.be/femmes-dans-les-mines-comment-extraire-l-egalite/' target='blank'>“Femmes dans les mines, comment extraire l’égalité?”</a> publié le 06 mars 2020.",
          },
        },
        {
          type: 'button',
          key: 'button-read-2',
          text: 'Je lis un article sur le travail des enfants en République démocratique du Congo',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonLire,
          iconHover: boutonLireHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            backgroundImage: backgoundPurple,
            type: 'text',
            title: "Protéger les enfants, un défi en République démocratique du Congo<br/><span class='subtitle'>Justice et Paix (résumé)</span>",
            text: "<span class='inline-title'>DES ENFANTS AU TRAVAIL</span>Selon un rapport publié par l’Unicef et l’Organisation Internationale du Travail (OIT) en juin 2021, 160 millions d’enfants sont forcés de travailler dans le monde. L’Afrique sub-saharienne est la région du monde la plus touchée par ce phénomène : 1 enfant sur 5 y serait astreint au travail.<span class='inline-title'>QUELLES SONT LES RAISONS DE CETTE SITUATION ?</span>En 2021, 60 % de la population de la RD Congo a moins de 18 ans. Cependant, seulement la moitié des enfants de 6 à 11 ans vont à l'école primaire. De nombreux enfants vivent encore dans les rues. A défaut d’une scolarisation accessible et de tout encadrement des structures étatiques, la précarité paralyse la vie familiale. Les enfants, filles et garçons, sont en proie à l’esclavagisme moderne. Ils et elles vont vers les mines, envoyé·e·s par leurs parents précarisés ou, pour certain·e·s aussi, en quête de moyens de subsistance pour leur famille. Les enfants sont utilisés comme auxiliaires des creuseurs en servant des repas, comme nettoyeurs de matériel ou comme transporteurs de lourds sacs de sable. Ces enfants sont ainsi exposés à des maladies causées par les produits chimiques utilisés pour l’extraction avec lesquels ils sont en contact fréquent.<br/><br/>Il arrive aussi que, dans le contexte conflictuel à l’est de la RD Congo, des enfants se fassent recruter de force par des groupes armés pour travailler dès leur plus jeune âge. La petite taille des enfants est utilisée comme un atout pour se faufiler dans les plus étroites galeries souterraines inaccessibles aux adultes qui, contrairement aux enfants, savent mieux évaluer les risques fatals d’asphyxie ou d’éboulement<br/><br/>La Constitution de la RD Congo du 18 février 2006 a voulu accorder une place centrale à l'enfant en s’engageant à faire de la protection de l'enfant son cheval de bataille. Elle souligne l'obligation de l'État à protéger l’enfant « contre toute atteinte à sa santé, à son éducation et à son développement mental ». Une loi spéciale protégeant l’enfant a été promulguée suite à de multiples pressions des associations. Mais en dépit de ces efforts, de nombreux enfants sont encore exploités dans les mines.<br/><br/>Ceci est un résumé de l’article de Justice et Paix <a href='https://www.justicepaix.be/lutilisation-denfants-dans-lexploitation-des-ressources-minieres-a-lest-de-la-rd-congo-entre-urgence-et-perspective/' target='_blank'>“L’utilisation d’enfants dans l’exploitation des ressources minières à l’est de la RD Congo: entre urgence et perspective”</a> publié le 25 juin 2021.",
          },
        },
      ],
      nextButtonStyle: {
        '&:hover': { color: colors.violet },
      },
      nextButtonText: 'Prendre une décision >',
      nextStepId: 'choice1',
    },
    {
      ...base_choice_style,
      id: 'info2',
      type: 'info',

      contentText:
        "Je ne sais vraiment pas quoi faire... Que ferais-tu, toi&nbsp;?<br/>Resterais-<span class='background-underlined large'>tu près du village</span> pour retrouver ta famille, ou te mettrais-tu <span class='background-underlined large'>en sécurité en t'él</span>oignant&nbsp;?",
      actionText: 'Je m’informe pour aider Sifa à prendre la bonne décision :',
      actions: [
        {
          type: 'button',
          key: 'button-read-1',
          text: 'Je lis un article sur l’insécurité dans l’est de la République démocratique du Congo',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonLire,
          iconHover: boutonLireHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            backgroundImage: backgoundPurple,
            type: 'text',
            title: "Un quotidien difficile pour les habitant&middot;e&middot;s<br/><span class='subtitle'>Justice et Paix (résumé)</span>",
            text: 'La situation sécuritaire qui prévaut à l’est de la RD Congo est alarmante et engendre son lot de violences quotidiennes. Les violations des droits humains tels que les massacres ethniques, les exactions, enlèvements, pillages ou encore le recrutement d’enfants dans des groupes armés, y sont nombreuses. Human Rights Watch impute ces violations envers les civils tant aux groupes armés (FDLR, ADF, NDC-R, Maï-Maï Yakatumba par exemple) qu’à des membres de l’armée régulière (FARDC). Selon un baromètre implémenté par l’ONG, 883 civil&middot;e&middot;s ont été tué&middot;e&middot;s et 1400 enlevé&middot;e&middot;s en 2018 dans les seules provinces des Nord et Sud-Kivu.<br/><br/>Le chaos qui s’observe dans la région crée un cadre de vie très dur pour les populations qui sont les premières victimes de l’exploitation anarchique et intensive des ressources. En effet, les épisodes de violences, les incursions des groupes armés dans les villages (avec les pillages ou encore les violences sexuelles massives) poussent régulièrement les populations à fuir leur habitation. Le tissu social est détruit et cela nuit gravement à la coexistence pacifique des populations. Ce qui amenuise davantage encore la possibilité d’une stabilisation et d’une pacification de la région à moyen terme.<br/><br/>Ceci est un résumé d’extraits du dossier pédagogique “Derrière nos écrans: les enjeux de l’exploitation minière. Zoom sur la République démocratique du Congo”, publié par Justice et Paix en 2019.',
          },
        },
        {
          type: 'button',
          key: 'button-read-2',
          text: 'Je lis un article sur les groupes armés présents à l’est de la République démocratique du Congo',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonLire,
          iconHover: boutonLireHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            backgroundImage: backgoundPurple,
            type: 'text',
            title: 'Plus de 100 groupes armés actifs dans l’est de la République démocratique du Congo',
            text: "Depuis une vingtaine d’années, de nombreux groupes armés sont présents dans les provinces de l’est de la République du Congo (Nord et Sud-Kivu, mais aussi Ituri et Maniema). On estime aujourd’hui qu’ils seraient entre 100 et 150, dont environ la moitié seraient effectivement en activité. La tendance observée depuis le début des années 2010 est une tendance à la fragmentation : en clair, il y a de plus en plus de petits groupes armés.<br/><br/>On connait des groupes originaires des pays limitrophes (ougandais, rwandais ou burundais) mais également des groupes congolais. Dans certains endroits, des villages ont mis sur pied des groupes « d’auto-défense », les Maï-Maï, qui prétendaient lutter contre des envahisseurs violents. Dans les faits, ces groupes se retrouvent bien souvent à commettre les mêmes délits que les autres et à exploiter les populations locales.<br/><br/>Qu’ils soient grands ou petits, d’origine étrangère ou locale, le point commun de ces groupes armés et une des raisons de leur présence sur cet espace particulier du territoire congolais est de s’attribuer les richesses du sous-sol, directement ou en exploitant les populations. Ces groupes contribuent en effet à un trafic international de minerais dans le but de s’enrichir, de s’acheter des armes et de garder le pouvoir sur la région. Les méthodes utilisées par les groupes sont différentes : certains creusent eux-mêmes pour trouver des minerais ; d’autres forcent des hommes, femmes et enfants à travailler pour eux ; d’autres encore rançonnent les creuseurs, soit directement sur le site, soit en construisant des barrages routiers. Dans tous les cas, ces groupes imposent leur volonté par la force et la violence. Si le gouvernement congolais essaie de coordonner des actions avec les gouvernements des pays voisins pour arrêter les bandes armées, de nombreux facteurs (géographie, manque de route, nombre d’acteurs impliqués…) compliquent cette action et cela permet aux groupes armés de jouir d’une certaine impunité.<br/><br/>Cet article fictif est inspiré du reportage de DW <a href='https://www.dw.com/fr/une-centaine-de-groupes-arm%C3%A9s-actifs-dans-lest-de-la-rdc/a-51664664' target='_blank'>“Une centaine de groupes armés actifs dans l’est de la RDC”</a> publié le 13 décembre 2019.",
          },
        },
      ],
      nextButtonStyle: {
        '&:hover': { color: colors.violet },
      },
      nextButtonText: 'Prendre une décision >',
      nextStepId: 'choice2',
    },
    //35
    {
      ...base_choice_style,
      id: 'info3',
      type: 'info',

      contentText:
        "<span class='background-underlined medium'>Quel dilemme</span>&thinsp;! Que ferais-tu, si c'était toi&nbsp;?<br/>Ferais-tu confiance aux hommes armés et r<span class='background-underlined large'>ejoindrais-tu leur bande</span>&nbsp;? Ou essayerais-tu d'aller à Bukavu pour t<span class='background-underlined large'>rouver tes cousins,</span> malgré les risques du voyage&nbsp;?",
      actionText: 'Je m’informe pour aider Sifa à prendre la bonne décision :',
      actions: [
        {
          type: 'button',
          key: 'button-read-1',
          text: 'Je lis un rapport sur les raisons qui poussent des enfants à rejoindre une bande armée',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonLire,
          iconHover: boutonLireHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            backgroundImage: backgoundPurple,
            type: 'text',
            title:
              "« Les enfants joignent les groupes armés afin d’être une force protectrice pour leur famille, leur groupe ethnique et leur communauté. »<br/><span class='subtitle'>Equipe spéciale pour les enfants et les conflits armés en RDC, MONUSCO (résumé)</span>",
            text: 'Le recrutement militaire d’enfants est majoritairement considéré hors la loi, mais 50 pays l’autorisent encore et beaucoup de groupes agissent en dehors de la loi lorsque cette pratique a été interdite.<br/><br/>Alors que les recrutements par les Forces Armées de la République démocratique du Congo (FARDC) ont progressivement réduit au cours des dix dernières années, le nombre d’enfants recrutés par les groupes armés et les milices est à nouveau en hausse, notamment depuis le début du conflit dans la région du Kasaï fin 2016. Il n’existe pas de chiffres précis relatifs aux enfants qui se joignent aux groupes armés (forcés ou non) dans l’est de la RDC. Cependant, certaines estimations générales suggèrent qu’un nombre significatif d’enfants participent au conflit armé. Depuis 2000, la MONUSCO a documenté l’implication de plus de 31 000 enfants dans des groupes armés dans le pays. Des groupes armés et milices locales opérant dans des états comme la République démocratique du Congo recrutent des enfants dès l’âge de quatre ou cinq ans en tant que porteurs, espions, messagers, ou à des fins d’exploitation sexuelle.<br/><br/>Des entretiens révèlent qu’en particulier pendant les périodes de basse intensité du conflit en RDC, pratiquement tous les enfants rejoignant un groupe armé le font “volontairement”, le recrutement forcé restant l’exception. Le recrutement des enfants, même s’il n’est pas contraint, semble toutefois naitre moins d’un désir que d’un choix fait au sein d’un ensemble limité d’options socio-économiques.<br/><span class="inline-title">FACTEURS D’INCITATION</span>Les conditions ou circonstances négatives dans une communauté ou un environnement auxquels les enfants échappent en rejoignant un groupe armé sont, par ex. pauvreté, chômage, faim, tribalisme, recherche d’un refuge pour échapper aux arrestations, mauvais traitements au sein du foyer, par la police ou par d’autres groupes armés, ou désir de vengeance.<span class="inline-title">FACTEURS D’ATTRACTION</span>Les récompenses positives ou incitations que les enfants anticipent pour rejoindre un groupe armé comprennent de la nourriture facilement disponible, un meilleur accès à l’argent, une protection accrue, un statut social amélioré, de meilleures options de vie et la capacité de défendre et protéger leur famille et communauté.<br/><br/>Ceci est un résumé d’extraits de la <a href="https://monusco.unmissions.org/sites/default/files/newsletter3_de_lequipe_speciale_des_nations_unies_pour_les_enfants_et_les_conflits_armes_en_rdc_0.pdf" target="_blank">newsletter</a> de l’Equipe spéciale des Nations Unies pour les enfants et les conflits armés en RDC (MONUSCO) publiée en janvier 2018.',
          },
        },
        {
          type: 'button',
          key: 'button-read-2',
          text: 'Je lis le témoignage de Mohamed, ancien enfant-soldat',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonLire,
          iconHover: boutonLireHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            backgroundImage: backgoundPurple,
            type: 'text',
            title: "Mohamed, capturé par un groupe armé et enfant-soldat à 9 ans<br/><span class='subtitle'>Équipe spéciale pour les enfants et les conflits armés en RDC, MONUSCO (résumé)</span>",
            text: '« Mon père était un commerçant. Il achetait et revendait des articles. Nous avons déménagé dans la localité de Beni où nous vivions paisiblement jusqu’au décès de mon père. Quelques jours après, ma mère nous a dit qu’il fallait à nouveau déménager sans préciser où nous allions. Sur le chemin, nous avons rencontré des hommes armés. C’était les ADF Nalu. J’étais rempli de peur. Ils nous ont arrêtés et m’ont pris avec eux. Avec le temps, j’ai fini par apprendre que ma mère était en complicité avec ce groupe pour que je sois des leurs.<br/><br/>Lorsque nous sommes arrivés dans leur camp, le groupe armé nous a immédiatement donné une formation militaire. Il y avait parmi nous des filles. Certains enfants étaient de mon âge. Après deux semaines de formation militaire, j’ai été nommé IO (Intelligence officer). J’étais donc devenu un agent de renseignement. Je collectais les informations et élaborais le plan de guerre contre le gouvernement. Durant tout le temps passé avec les ADF Nalu, je n’étais pas payé. Je me nourrissais de ce que je pouvais trouver dans la brousse, pratiquement à 25 km du lieu où nous étions basés.<br/><br/>Je ne peux pas compter le nombre de personnes que j’ai été forcé à tuer. Je ne pouvais pas faire autrement. C’était le seul moyen pour se protéger contre les ennemis. Ils nous ont dit que les ennemis étaient les FARDC ou la population.<br/><br/>Un jour, nous avons mené une attaque contre les FARDC. Beaucoup d’entre nous ont été tués. Quant à moi, j’ai été blessé à la main. Les FARDC m’ont alors remis aux agents de protection de l’enfant qui m’ont soigné et permis que je sois scolarisé. <br/><br/>Je préfère de loin cette nouvelle vie à celle que je menais au sein de ce groupe armé. J’ai vécu beaucoup de choses horribles qu’un enfant ne devrait pas expérimenter. Je déconseille à tout enfant d’intégrer un groupe armé. Nous n’y avons pas notre place »<br/><br/>Ceci est un résumé d’extraits de la <a href="https://monusco.unmissions.org/sites/default/files/newsletter3_de_lequipe_speciale_des_nations_unies_pour_les_enfants_et_les_conflits_armes_en_rdc_0.pdf" target="_blank">newsletter</a> de l’Equipe spéciale des Nations Unies pour les enfants et les conflits armés en RDC (MONUSCO) publiée en janvier 2018.',
          },
        },
      ],
      nextButtonStyle: {
        '&:hover': { color: colors.violet },
      },
      nextButtonText: 'Prendre une décision >',
      nextStepId: 'choice3',
    },
    {
      ...base_choice_style,
      id: 'info4',
      type: 'info',

      contentText:
        'Je ne sais pas quelle est la bonne décision à prendre. Dans cette situation, que ferais-tu&nbsp;?<br/> Discu<span class="background-underlined very-large">terais-tu avec tes cousins</span> pour les convaincre de te laisser rester chez eux&nbsp;? Ou tenterais<span class="background-underlined very-large">-tu ta chance en Ouganda</span>&nbsp;?',
      actionText: 'Je m’informe pour aider Sifa à prendre la bonne décision :',
      actions: [
        {
          type: 'button',
          key: 'button-read-1',
          text: 'Je lis un article sur “l’hospitalité ougandaise”',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonLire,
          iconHover: boutonLireHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            backgroundImage: backgoundPurple,
            type: 'text',
            title: 'L’Ouganda serait le pays le plus accueillant au monde',
            text: 'L’Ouganda est le 4e pays au monde qui accueille le plus de réfugiés ; on n’y comptait pas moins de 1,4 millions de personnes réfugiées en juin 2021. Ces personnes proviennent surtout des pays voisins : République démocratique du Congo, Burundi et Sud-Soudan.<br/><br/>Si on dit que l’Ouganda serait le pays le plus accueillant au monde, c’est que ce pays applique une politique d’accueil des réfugiés qui permet de garantir leurs droits essentiels. Les personnes réfugiées en Ouganda peuvent en effet se déplacer librement, exercer une profession, créer une entreprise, accéder à des soins de santé et à l’éducation pour eux-mêmes et pour leurs enfants… L’état ougandais cède également aux personnes réfugiées des parcelles de terre afin qu’elles puissent se construire une habitation et cultiver.<br/><br/>Le gouvernement ougandais défend cette politique d’ouverture au regard de l’Histoire récente de l’Ouganda, qui est également un pays qui a connu des troubles et dont une partie de la population a connu les chemins de l’exil. À présent que l’Ouganda est un territoire qui connait la paix, le gouvernement souhaite être une terre d’accueil pour les personnes dans le besoin. La vision majoritaire des personnes réfugiées est plutôt positive dans la population ougandaise : on les voit comme des sources de richesse, des personnes avec leurs talents capables de s’intégrer dans l’économie locale et de la faire prospérer – et pas comme des envahisseurs.<br/><br/>Cet article fictif est inspiré du reportage d’Africanews <a href="https://www.un.org/africarenewal/fr/magazine/d%C3%A9cembre-2018-mars-2019/r%C3%A9fugi%C3%A9s-l%E2%80%99hospitalit%C3%A9-ougandaise" target="_blank">“Réfugiés: l’hospitalité ougandaise”</a> publié en décembre 2018.',
          },
        },
        {
          type: 'button',
          key: 'button-read-2',
          text: 'Je lis le témoignage de Divine, réfugiée dans un camp en Ouganda',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonLire,
          iconHover: boutonLireHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            backgroundImage: backgoundPurple,
            type: 'text',
            title: 'Camp de réfugiés: à l’abri, mais sans avenir',
            text: '<span class="inline-title">RETROUVER LA PAIX</span>Divine a 20 ans et est originaire de la province d’Ituri, au nord-est de la République démocratique du Congo. Elle vient de rejoindre l’Ouganda, fuyant la violence de sa province natale avec son mari et sa petite fille en traversant le lac Albert en barque.<br/><br/>“Nous sommes arrivés en Ouganda sur une barque avec une cinquantaine de personnes, raconte Divine. Quand notre village a été incendié, nous avons rejoint le lac au plus vite. La traversée a duré longtemps. Quand nous sommes arrivés dans un village de pêcheurs en Ouganda, nous avons été emmenés par bus dans ce qui s’appelle un centre d’accueil. Puis nous avons encore pris un autre bus pour rejoindre un terrain vide très loin. Là, on s’est construit un abri avec du bois et des bâches.”<br/><br/>“Quand je suis arrivée en Ouganda, je me suis sentie très soulagée. Ici, il y a beaucoup de monde mais apparemment pas de violence. Je peux dormir sans garder un œil ouvert, sans avoir peur de devoir m’enfuir au milieu de la nuit. Vivre en paix est la chose la plus importante.  Le Congo est mon pays, mais je ne voudrais pas y retourner ; j’ai perdu toute ma famille, il ne reste que mon mari et moi. Nous avons l’intention de rester pour construire notre vie ici.”<span class="inline-title">UNE EXISTENCE EN SUSPENS</span>La vie n’est pourtant pas facile dans le camp. Ouvert au début de l’année 2018, il a une capacité d’accueil de 100 000 personnes... Et déjà plus de 90 000 personnes sont enregistrées. On compte 1000 arrivées par jour environ.<br/><br/>Avec un nombre de personnes aussi élevé, beaucoup de choses se compliquent. La nourriture manque rapidement, et l’accès à l’eau est limité. Comme Divine et sa famille ont eu des problèmes pour s’enregistrer à leur arrivée, ils n’ont pas reçu tout de suite de carte de rationnement et ont dû compter sur la générosité d’autres réfugiés pour obtenir de la nourriture.  Des voisins ont partagé leur ration avec eux. “On ne peut rien se procurer. Nous buvons toute l’eau que nous trouvons, peu importe la saleté. Quand on la fait bouillir, on peut la boire, explique Divine.”<br/><br/>Divine espère que son passage dans le camp sera temporaire, car elle a l’impression que sa vie, celle de son mari et celle de son enfant sont en suspens. “Ici, nous ne sommes pas en danger, mais nous ne faisons rien, nous passons le temps à discuter avec les voisins. Je voudrais trouver un emploi ou suivre une formation ; mais on n’en donne pas dans le camp. En ce moment, je ne peux rien faire pour construire mon avenir, se désole-t-elle.”<br/><br/>Cet article fictif est inspiré du reportage d’Oxfam International <a href="https://www.oxfam.org/fr/en-ouganda-la-vie-en-suspens-des-refugies-sud-soudanais" target="_blank">“En Ouganda, la vie en suspens des réfugiés sud-soudanais"</a> publié en 2018',
          },
        },
        {
          type: 'button',
          key: 'button-ask',
          text: 'Je demande à Sifa : “Que dit ton cœur?”',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonCoeur,
          iconHover: boutonCoeurHoover,
          action: 'openDialog',
          dialogContent: {
            type: 'image',
            imageSrc: PhylactereChezNous,
            imageStyle: { marginBottom: '15vh', width: '30vw', maxWidth: '400px', height: 'auto', maxHeight: '50vh', objectFit: 'contain', objectPosition: 'center' },
          },
        },
      ],
      nextButtonStyle: {
        '&:hover': { color: colors.violet },
      },
      nextButtonText: 'Prendre une décision >',
      nextStepId: 'choice4',
    },
    {
      ...base_choice_style,
      id: 'info bukavu ou ouganda',
      type: 'info',

      contentText:
        '<span class="background-underlined medium">C’est vraim</span>ent une décision difficile... Que ferais-tu, toi&nbsp;?<br/><span class="background-underlined medium">Resterais-tu</span> à Bukavu, essayerais-tu de <span class="background-underlined large">traverser la frontière</span> vers l’Ouganda par tes propres moyens, ou <span class="background-underlined very-large">emprunterais-tu de l’argent</span> à tes cousins&nbsp;?',
      actionText: 'Je m’informe pour aider Sifa à prendre la bonne décision :',
      actions: [
        {
          type: 'button',
          key: 'button-watch-1',
          text: 'J’écoute le témoignage de Salem, qui a dû fuir en Ouganda',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            type: 'video',
            videoIframe: getYoutubeIframe('fww-vIHcyUI'),
          },
        },
        {
          type: 'button',
          key: 'button-read-1',
          text: 'Je lis l’interview d’un médecin de Bukavu',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonLire,
          iconHover: boutonLireHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            backgroundImage: backgoundPurple,
            type: 'text',
            title: "Interview du Dr Denis Mukwege, Prix Nobel de la Paix 2018<br/><span class='subtitle'>ONU Femmes France (résumé)</span>",
            text: 'En République démocratique du Congo, le professeur Denis Mukwege, Prix Nobel de la Paix 2018, est l’un des spécialistes mondiaux du traitement des mutilations génitales. Surnommé « l’homme qui répare les femmes », il se bat aussi pour faire entendre la voix de ces femmes, au mépris du danger, et réclamer la justice et la fin de l’impunité des responsables des guerres, massacres et crimes qui ont jalonné l’histoire récente de son pays. <span class="inline-title">QU’EST-CE QUE LA FONDATION PANZI ET QUELLE EST SA MISSION ?</span>Dr Denis Mukwege : La Fondation Panzi, créée le 12 juin 2008, a pour objectif de faire des femmes « des actrices à part entière dans une société où règne la cohésion sociale ». Sa mission est d’œuvrer à l’épanouissement intégral des femmes au travers d’une prise en charge psychologique, juridique et socio-économique complétant le traitement médical des femmes victimes des violences sexuelles.<br/><br/>Depuis la création de l’Hôpital de Panzi en 1999, près de 100 000 patientes, dont presque 55 000 survivantes de violences sexuelles et plus de 45 000 patientes souffrant de pathologies gynécologiques graves y ont été soignées. Grâce à nos 370 médecins, infirmièr.e.s et personnel de soutien qualifié.e.s et dévoué.e.s, près de 18 000 consultations sont effectuées chaque année à l\'hôpital et dans ses cliniques de proximité en milieu rural. <span class="inline-title">QUELLE EST VOTRE APPROCHE DANS LA PRISE EN COMPTE ET LE TRAITEMENT DES VICTIMES DE VIOLENCES SEXUELLES ? </span>Dr Denis Mukwege : Nous avons mis en place un programme holistique de prise en charge des Femmes Victimes des Violences Sexuelles (FVVS). Chaque femme collabore avec nos médecins, nos clinicien.ne.s et nos assistant.e.s sociales.aux pour créer un parcours de guérison physique et psychologique adapté. Suite à cela, si la victime est en mesure d’identifier son bourreau, la Fondation lui accorde une aide juridique. Enfin, à la sortie de l’hôpital, notre personnel propose une médiation et des conseils pour faciliter la réintégration de chacune. Une aide financière, sous forme de microcrédit, est également octroyée à la victime afin de lui permettre de créer une activité génératrice de revenu. Il faut briser les tabous et sortir des complexes de victimisation pour amener les femmes à devenir des actrices à part entière de la société. L’autonomisation et le leadership des femmes sont les seules armes pour transformer leur victimisation en victoire, la souffrance en force et en pouvoir pour retrouver le chemin de la dignité bafouée.<br/><br/>Ceci est un résumé d’extraits de <a href="https://www.onufemmes.fr/nos-actualites/interview-du-dr-mukwege-prix-nobel-de-la-paix-2018" target="_blank">l’interview du Dr Denis Mukwege</a> menée par Sophie Pouget pour ONU Femmes France, publiée le 01 octobre 2020.',
          },
        },
      ],
      nextButtonStyle: {
        '&:hover': { color: colors.violet },
      },
      nextButtonText: 'Prendre une décision >',
      nextStepId: 'choice bukavu ou ouganda',
    },
    {
      ...base_choice_style,
      id: 'info kampala',
      type: 'info',

      contentText:
        '<span class="background-underlined medium">Je ne sais p</span>as quoi faire. À ma place, que ferais-tu&nbsp;?<br/>Par<span class="background-underlined very-large">tirais-tu travailler seule à Kampala</span>&nbsp;? Emmènerais-tu <span class="background-underlined large">tes frères avec t</span>oi&nbsp;? Ou resterais-tu dans <span class="background-underlined large">le camp de réfugi</span>és&nbsp;?',
      actionText: 'Je m’informe pour aider Sifa à prendre la bonne décision :',
      actions: [
        {
          type: 'button',
          key: 'button-read-1',
          text: 'J’écoute le témoignage de Salem, qui me parle de son quotidien en Ouganda',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            type: 'video',
            videoIframe: getYoutubeIframe('g56e0HHPP3w'),
          },
        },
        {
          type: 'button',
          key: 'button-watch-1',
          text: 'J’écoute l’interview de Laurens, expert Caritas, qui m’explique ce qu’est la réinstallation',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            type: 'video',
            videoIframe: getYoutubeIframe('R7fuETHbA2w'),
          },
        },
        {
          type: 'button',
          key: 'button-ask',
          text: 'Je demande à Sifa : “Que dit ton cœur?”',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonCoeur,
          iconHover: boutonCoeurHoover,
          action: 'openDialog',
          dialogContent: {
            type: 'image',
            imageSrc: PhylactereFrere,
            imageStyle: { marginBottom: '15vh', width: '30vw', maxWidth: '400px', height: 'auto', maxHeight: '50vh', objectFit: 'contain', objectPosition: 'center' },
          },
        },
      ],
      nextButtonStyle: {
        '&:hover': { color: colors.violet },
      },
      nextButtonText: 'Prendre une décision >',
      nextStepId: 'choice kampala',
    },
    {
      ...base_choice_style,
      id: 'info final',
      type: 'info',
      contentText:
        'Je ne sais pas quelle décision prendre. Toi, <span class="background-underlined medium">que ferais-tu</span>&nbsp;?<br/>Chercherais-tu <span class="background-underlined medium">du travail</span>, choisirais-tu <span class="background-underlined large">d’étudier à temps plein</span>, ou essayerais-tu <span class="background-underlined very-large">d’étudier et de travailler</span> après les cours ?',
      actionText: 'Je m’informe pour aider Sifa à prendre la bonne décision :',
      actions: [
        {
          type: 'button',
          key: 'button-watch-1',
          text: 'J’écoute le témoignage de Salem,  qui me parle de son arrivée en Belgique',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            type: 'video',
            videoIframe: getYoutubeIframe('N1Ggmg8xw2A'),
          },
        },
        {
          type: 'button',
          key: 'button-watch-2',
          text: 'J’écoute le témoignage de Prince, qui a eu différentes difficultés en arrivant en Belgique',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            type: 'video',
            videoIframe: getYoutubeIframe('dsRIXV6hsTw'),
          },
        },
      ],
      nextButtonStyle: {
        '&:hover': { color: colors.violet },
      },
      nextButtonText: 'Prendre une décision >',
      nextStepId: 'choice final',
    },
    //40
  ],
};
